
export default [
    {
        path: "/group/disabled",
        name: "group_disabled",
        meta: {
            error: {
                icon: "lock",
                title: "This group has been disabled.",
                description: "Please reload the page to try again."
            }
        },
        component: () => import(/* webpackChunkName: "error_page" */ "../views/ErrorPage.vue")
    }
]